import React from "react";
import { Check } from "lucide-react";
import { useModals } from "@/lib/modal-context";

const WhatsIcon = ({ className = "w-5 h-5" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M19.05 4.91A9.83 9.83 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.74.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.91-7.02Z"/>
    </svg>
);

const BADGES = ["100% Satisfaction Guarantee", "No Hidden Costs", "Best Price Guaranteed"];

export default function PreFooterCTA() {
    const { openConnect } = useModals();
    return (
        <section className="bg-white py-12 sm:py-16">
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-[2rem] bg-[#111111] p-8 sm:p-12 lg:p-16 text-white">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                        <div className="lg:col-span-7 fade-up">
                            <div className="text-[#CCFF00] text-xs font-bold tracking-[0.22em]">
                                — LET&apos;S DESIGN SOMETHING AMAZING TOGETHER
                            </div>
                            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight">
                                Let&apos;s Bring Your Dream Space To Life.
                            </h2>
                            <div className="mt-7 flex flex-wrap gap-2">
                                {BADGES.map((b) => (
                                    <span key={b} className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1.5 text-xs font-semibold">
                                        <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#CCFF00]">
                                            <Check className="h-3 w-3 text-black" />
                                        </span>
                                        {b}
                                    </span>
                                ))}
                            </div>
                            <button
                                onClick={() => openConnect({ source: "prefooter" })}
                                data-testid="prefooter-connect"
                                className="mt-8 btn-pill btn-lime pr-1.5"
                            >
                                <span className="px-1 text-sm font-bold">CONNECT IN 15 SECS</span>
                                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-black text-[#CCFF00]">
                                    <WhatsIcon className="h-4 w-4" />
                                </span>
                            </button>
                        </div>
                        <div className="lg:col-span-5">
                            <div className="relative rounded-3xl overflow-hidden h-72 lg:h-96">
                                <img
                                    src="https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&w=1100&q=80"
                                    alt="Premium furniture"
                                    className="absolute inset-0 h-full w-full object-cover"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
